import React from "react";
import { Link } from "react-router-dom";
const Logboekenmenu = ({ token, username, isActive, onToggle }) => {
  if (username.bedrijf && username.bedrijf.modules.includes("logboeken")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker" ) {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon"><i className="fa fa-book"></i></span>
            <span className="menu-text">Logboeken</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}><i className="fas fa-chevron-right"></i></span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/logboek" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">Overzicht</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/logboek/vergelijken" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">Parken Vergelijken</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/logboek/website" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">Invullen vanuit website</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/logboek/insert" className="menu-link">
                <span className="menu-icon"><i className="fa fa-book"></i></span>
                <span className="menu-text">Handmatig Invullen</span>
              </Link>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default Logboekenmenu;
